import { Circles } from 'react-loader-spinner';

const PageLoader = () => {
  return (
    <div className="flex justify-center items-center h-screen">
      <Circles height="80" width="80" color="#A8D34B" ariaLabel="loading" visible={true} />
    </div>
  );
};

export default PageLoader;